module.exports = __webpack_public_path__ + "34736292/img/boston-lights.a623432f.png";